module.exports = {"210504001":"金山街道","210504002":"北地街道","210504004":"高峪街道","210504005":"明山街道","210504007":"东兴街道","210504008":"新明街道","210504009":"牛心台街道","210504010":"卧龙街道","210504011":"高台子街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210504.json
// module id = 541
// module chunks = 0